import { isEmpty } from 'lodash';
import { Children, HTMLAttributes } from 'react';
import { makeStyles } from 'tss-react/mui';

import { COLORS } from '@/styles/tokens/colors';
import { WithClasses } from '@/styles/types';

import { TileGroupItem } from './TileGroupItem';
import { TileFontSizeVariant, TileVariant } from './types';

const useStyles = makeStyles()((_theme) => ({
  root: {
    backgroundColor: COLORS.PRIMITIVES.WHITE,
    overflow: 'hidden',
    height: '100%',
    overflowY: 'auto',
    padding: '8px 0',
  },
  itemsCount: {
    '&:hover': {
      backgroundColor: COLORS.PRIMITIVES.WHITE,
    },
  },
}));

export interface TileGroupProps extends HTMLAttributes<HTMLDivElement> {
  classes?: WithClasses<typeof useStyles>;
  hideItemCount?: boolean;
  tileVariant: TileVariant;
  /** A hex color that replaces the palette of `tileVariant`. */
  tileCustomColor?: string;
  fontSizeVariant: TileFontSizeVariant;
}

export const TileGroup = ({
  classes: externalClasses,
  children,
  hideItemCount,
  tileVariant,
  tileCustomColor,
  fontSizeVariant,
  ...props
}: TileGroupProps): JSX.Element => {
  const { classes } = useStyles(undefined, {
    props: { classes: externalClasses },
  });

  const childrenCount = Children.toArray(children).filter(
    (c) => !isEmpty(c)
  ).length;

  return (
    <div className={classes?.root} {...props}>
      {!hideItemCount && (
        <TileGroupItem
          typographyProps={{ variant: 'title-xs' }}
          description={`Items (${childrenCount})`}
          classes={{ root: classes.itemsCount }}
          tileVariant={tileVariant}
          tileCustomColor={tileCustomColor}
          fontSizeVariant={fontSizeVariant}
        />
      )}
      {children}
    </div>
  );
};
